import React from 'react';
import { useCart } from '../../../stores/cartStore';

const CartIcon = ({ onClick }) => {
  const { totalItems } = useCart();

  return (
    <button 
      onClick={onClick}
      className="relative text-gray-600 hover:text-gray-900 transition-colors"
      title="View Cart"
    >
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.293 2.293A1 1 0 007 16h10a1 1 0 100 2H7a3 3 0 01-3-3V6a1 1 0 011-1z" 
        />
      </svg>
      
      {totalItems > 0 && (
        <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-semibold">
          {totalItems > 99 ? '99+' : totalItems}
        </span>
      )}
    </button>
  );
};

export default CartIcon;
